module.exports = __webpack_public_path__ + "static/img/4.291fef7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/3/eng/4.png
// module id = wh4o
// module chunks = 0